// extracted by mini-css-extract-plugin
export default {"container":"ContactWithClient_container__nNThZ","name":"ContactWithClient_name__HOccO","data":"ContactWithClient_data__6BTE2"};